import {Component, OnInit} from '@angular/core';
import {Game} from '../../../domain/game';
import {ActivatedRoute, Router} from '@angular/router';
import {GameService} from '../../game.service';

@Component({
  selector: 'sg-endquestions',
  templateUrl: './endquestions.component.html',
  styleUrls: ['./endquestions.component.scss']
})
export class EndquestionsComponent implements OnInit {

  step = 1;
  feedbackWritten = false;

  game: Game = {
    players: [
      {name: 'Placeholder', age: null, anxChoice: null, anxChoiceAfter: null, avatarIcon: 0, gender: null, wisdomCards: 0}
    ]
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private gameService: GameService) {
  }

  ngOnInit() {
    this.gameService.getGame(this.activatedRoute.snapshot.params.id).subscribe(game => {
      this.game = game;
    });

  }

  gotoStep(event) {
    if (event != null) {
      this.step = this.step + 1;
      this.feedbackWritten = true;
    } else {
      this.step = this.step + 1;
    }
  }
}
